import { Layout } from "components/Layout";

export default function ModuleRootPage() {
  return (
    <Layout>
      <h1>ModuleRootPage</h1>
    </Layout>
  );
}
